import {
  CaseReducer,
  PayloadAction,
  SliceCaseReducers,
  createSlice
} from "@reduxjs/toolkit";
import { QueryArgsSlice, initialState } from "./initialState";
import { SearchCatalogArgs } from "./searchCatalog";
import { AuthoringDashboardArgs } from "./authoringDashboardArgs";

type GeneratedReducers<T> = {
  [Property in keyof T]: CaseReducer<T, PayloadAction<T[Property] | undefined>>;
};

type CustomReducer = GeneratedReducers<QueryArgsSlice>;
export const queryArgsSlice = createSlice({
  name: "queryArgsSlice",
  initialState,
  reducers: {
    searchCatalogArgs: (state, action) => {
      return {
        ...state,
        searchCatalogArgs: action?.payload
          ? action.payload
          : initialState.searchCatalogArgs
      };
    },
    authoringCatalogArgs: (state, action) => {
      return {
        ...state,
        authoringCatalogArgs: action?.payload
          ? action.payload
          : initialState.authoringCatalogArgs
      };
    },
    setNextPage(state) {
      return {
        ...state,
        searchCatalogArgs: {
          ...state?.searchCatalogArgs,
          pageNumber: state?.searchCatalogArgs?.pageNumber + 1
        }
      };
    },
    setResetPage(state) {
      return {
        ...state,
        searchCatalogArgs: {
          ...state?.searchCatalogArgs,
          pageNumber: 1
        }
      };
    },
    setNote: (state, action: PayloadAction<QueryArgsSlice["upsertNote"]>) => {
      const noteId = action?.payload?.id!;
      return {
        ...state,
        upsertNote: {
          ...action?.payload
        },
        getNotesArgs: {
          ...state.getNotesArgs,
          noteId
        },
        noteId
      };
    },
    setNoteMessage: (
      state,
      action: PayloadAction<QueryArgsSlice["upsertNoteMessage"]>
    ) => {
      return {
        ...state,
        upsertNoteMessage: {
          ...action?.payload
        }
      };
    },
    setNextNotePages: (state, action: PayloadAction<number | undefined>) => {
      const pageNumber =
        action?.payload === 0
          ? action?.payload
          : state?.getNotesArgs?.pageNumber + 1;
      return {
        ...state,
        getNotesArgs: {
          ...state?.getNotesArgs,
          pageNumber
        }
      };
    },
    setIsNoteEdit: (
      state,
      action: PayloadAction<{
        isNoteEdit: QueryArgsSlice["isNoteEdit"];
        noteToUpdate?: QueryArgsSlice["upsertNoteMessage"];
      }>
    ) => {
      return {
        ...state,
        isNoteEdit: action?.payload?.isNoteEdit,
        upsertNoteMessage: action?.payload?.isNoteEdit
          ? action?.payload?.noteToUpdate!
          : initialState.upsertNoteMessage
      };
    },
    setAttachment: (
      state,
      // action: PayloadAction<QueryArgsSlice["upsertNoteMessage"]["attachments"]>,
      action: PayloadAction<any>
    ) => {
      return {
        ...state,
        upsertNoteMessage: {
          ...state?.upsertNoteMessage,
          attachments: action?.payload
        }
      };
    },
    setNextAuthoringPage: (state, _action) => {
      return {
        ...state,
        authoringCatalogArgs: {
          ...state?.authoringCatalogArgs,
          // pageNumber: state?.authoringCatalogArgs?.pageNumber + 1,
          pageNumber: (state?.authoringCatalogArgs?.pageNumber || 0) + 1
        }
      };
    }
  }
});

export const { actions: queryArgsActions } = queryArgsSlice;

// export type CustomCaseReducer<T> = {
//   setState: CaseReducer<
//     T,
//     PayloadAction<{
//       name: keyof T;
//       // data:  T[keyof T];
//       data: T[keyof T];
//     }>
//   >;
//   resetState: CaseReducer<
//     T,
//     PayloadAction<keyof T>
//   >;
// };
